import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { CircularProgress, Grid } from '@material-ui/core';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  wrapper: {
    position: 'relative',
  },
  root: {
    verticalAlign: 'middle',
  },
  circle: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    verticalAlign: 'middle',
    color: palette.progress.background,
  },
  barColorPrimary: {
    color: palette.progress.backgroundValue,
  },
  completeIcon: {
    height: 10,
    width: 10,
    color: '#00AD8D',
  },
}), { name: 'ProgressUploadPanel' });

type Props = {
  value: number;
  isStatic?: boolean;
};

const Progress = ({ value, isStatic = false }: Props) => {
  const classes = useStyles();

  return (
    <Grid item className={classes.wrapper}>
      <CircularProgress
        value={100}
        variant="determinate"
        classes={{
          root: classes.circle,
        }}
        style={{
          width: 20,
          height: 20,
        }}
      />
      <CircularProgress
        value={value}
        variant={isStatic ? 'static' : undefined}
        classes={{
          root: classes.root,
          circle: classes.barColorPrimary,
        }}
        style={{
          width: 20,
          height: 20,
        }}
      />
    </Grid>
  );
};

export default Progress;
